import { Dialog } from "@radix-ui/react-dialog";
import React from "react";
import {
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";
import { IoCloseCircle } from "react-icons/io5";

const SqlErrorDialog = ({ errors, children, setIsOpen, isOpen }) => {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger>{children}</DialogTrigger>
      <DialogContent className=" bg-zinc-900 border-zinc-800">
        <DialogHeader>
          <DialogTitle className="tracking-wide text-base">
            SQL Error Details
          </DialogTitle>
        </DialogHeader>
        <div className="">
          <ul>
            {errors.map((error) => {
              return (
                <li className="text-xs flex gap-2 items-center">
                  <IoCloseCircle className="text-red-500 w-5 h-5 self-start" />
                  <span>{error}</span>
                </li>
              );
            })}
          </ul>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SqlErrorDialog;
